import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditPencil from '../../../../../Assets/StorefrontIcons/EditPencil.svg';
import Delete from '../../../../../Assets/DeleteRed.svg';
import { setSectionType, setSectionFormType, removeAboutSection } from '../../../../../Features/storefrontSlice';
import { formatDescription } from '../../../../../lib/utils/utils';

function FeatureSection({ feature }) {
    const [iconSize, setIconSize] = useState(0);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [headingSize, setHeadingSize] = useState(0);
    const [headingHeight, setHeadingHeight] = useState(0);

    const [descSize, setDescSize] = useState(0);
    const [descHeight, setDescHeight] = useState(0);

    useEffect(() => {
        setIconSize((zoomSize/100)*15);

        setHeadingSize((zoomSize/100)*10);
        setHeadingHeight((zoomSize/100)*18);

        setDescSize((zoomSize/100)*6);
        setDescHeight((zoomSize/100)*14);
    }, [zoomSize]);

    return (
        <div className="flex gap-[6px]">
            <div style={{ width: `${iconSize}px`, height: `${iconSize}px` }}>
                <img className='size-full' src={feature?.imageLink} alt={feature.altText} />
            </div>

            <div style={{ width: `calc(100% - ${iconSize}px)` }} className="flex flex-col gap-1">
                <h1 style={{ fontSize: `${headingSize}px`, lineHeight: `${headingHeight}px` }} className='font-semibold text-[#000000]'>{feature.Heading}</h1>

                <p style={{ fontSize: `${descSize}px`, lineHeight: `${descHeight}px` }} className='font-medium text-[#666666]'>
                    <span dangerouslySetInnerHTML={{ __html: formatDescription(feature.Description || '') }} />
                </p>
            </div>
        </div>
    );
}

function FeaturesOne({ item }) {
    const dispatch = useDispatch();

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const mobileItem = versionStack[versionIndex]?.storeAbout.find(section => section.item.TypeData === item.item.TypeData);

    const [buttonsVisible, setButtonsVisible] = useState(false);
    const [hoverOnBox, setHoverOnBox] = useState(false);

    useEffect(() => {
        if(hoverOnBox) {
            setButtonsVisible(true);
        } else {
            setButtonsVisible(false);
        }
    }, [hoverOnBox]);

    function handleEditClick() {
        dispatch(setSectionType('SECTION'));
        dispatch(setSectionFormType('FEATURES_ONE_DESKTOP'));
    }

    function handleDeleteClick() {
        dispatch(removeAboutSection({ item, mobileItem }));
    }

    return (
        <div 
            onMouseEnter={() => setHoverOnBox(true)} 
            onMouseLeave={() => setHoverOnBox(false)} 
            className='w-full grid grid-cols-2 gap-x-2 gap-y-2 px-4 relative'
        >
            {
                buttonsVisible && 
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 flex items-center rounded-md overflow-hidden bg-[#FFFFFF]">
                    <button onClick={handleEditClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={EditPencil} alt="" />
                    </button>
                    <button onClick={handleDeleteClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={Delete} alt="" />
                    </button>
                </div>
            }

            {item.item.featureItems.map((feature, index) => {
                return (
                    <FeatureSection 
                        key={index} 
                        feature={feature}
                    />
                )
            })}
        </div>
    );
}

export default FeaturesOne;
